// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PrescriptionModel } from './prescriptionModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PrescriptionV2AccountPrescriptionGetByAccountIdResponse {
    'data': Array<PrescriptionModel>;
    'success': boolean;
    'messages': Array<string> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PrescriptionV2AccountPrescriptionGetByAccountIdResponse>> = [
        {
            "name":     "data",
            "baseName": "data",
            "type":     "Array<PrescriptionModel>"
        },
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return PrescriptionV2AccountPrescriptionGetByAccountIdResponse.attributeTypeMap;
    }
}
